module.exports = __webpack_public_path__ + "img/mobile-58.3814b4f5.png";